

const baseURL = "http://91.109.117.92:8089/api/v1/generate";
const otpEndpoint = "http://91.109.117.92:8089/api/v1/send-sms";
const validateOtpEndpoint = "http://91.109.117.92:8089/api/v1/validate-otp";
export const LoginEndpoint = "http://91.109.117.92:8089/api/v1/login";
export const RegisterEndpoint = "http://91.109.117.92:8089/api/v1/register";
const recaegeWalletEndpoint = "http://91.109.117.92:8089/api/v1/recharge-wallet";
const getWalletbalance = "http://91.109.117.92:8089/api/v1/get-wallet-balance";
const getMyWinnings = "http://91.109.117.92:8089/api/v1/my-winnings";

// const baseURL = "http://91.109.117.92:8089/api/v1/generate/";
// const otpEndpoint = "http://91.109.117.92:8089/api/v1/send-sms/";
// const validateOtpEndpoint = "http://91.109.117.92:8089/api/v1/validate-otp/";
// const recaegeWalletEndpoint = "http://91.109.117.92:8089/api/v1/recharge-wallet/";
// const getWalletbalance = "http://91.109.117.92:8089/api/v1/get-wallet-balance/";
// const getMyWinnings = "http://91.109.117.92:8089/api/v1/my-winnings/";

const createTicketIssue =
  "https://bytecodesupport.com/api/v1/create-ticket-externally";

export const spinResultURL = `${baseURL}`;
export const sendOtpURL = `${otpEndpoint}`;
export const confirmOtpURL = `${validateOtpEndpoint}`;
export const recargeWallet = `${recaegeWalletEndpoint}`;
export const getWallet = `${getWalletbalance}`;
export const myWinnings = `${getMyWinnings}`;
export const createTicket = `${createTicketIssue}`;

// import axios from 'axios';
// axios.defaults.baseURL = 'http://localhost:1010/'
// axios.defaults.headers.common = {'Authorization': `bearer ${token}`}
// export default axios;
